import { render, staticRenderFns } from "./InterviewExamPoint.vue?vue&type=template&id=3f760f9f"
import script from "./InterviewExamPoint.vue?vue&type=script&lang=js"
export * from "./InterviewExamPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports